import React from "react";

class Headline extends React.Component {
    render() {
        return (
            <div className="title-container">
                <h1 className="app-title">React Weather App</h1>
            </div>
        );
    }
}
export default Headline;